import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";
import DataTable from "react-data-table-component";
import { Routes } from "src/constant/api_url";
import { Box, Card, CircularProgress, Grid, Modal, Typography } from "@mui/material";
import { Stack, Container, TextField, Button, Tooltip, IconButton } from "@mui/material";
import Page from "src/components/Page";
import { CSVLink } from "react-csv";
import { notification } from "src/utils/messages";
import Label from "src/components/Label";
import { DeleteSharp, FileUploadRounded } from "@mui/icons-material";
import {
  addBlockMemberApi,
  deleteBlockMemberList,
  getBlockListVisitorListByMobile
} from "src/api/commonapi";
import { getBlockMemberCommonFunction } from "src/utils/common";
import Deletemodal from "./DeleteModal";
import CustomLoader from "src/commonComponents/CustomLoader";
import normalizeSearch from "src/utils/normalizeSearch";

export default function MemberBlockList() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  const MemberModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [step, setStep] = useState(0);

  const [openUploadModal, setOpenUploadModal] = useState(false);
  const toggleOpenUploadModal = () => setOpenUploadModal(!openUploadModal);
  const [fileUploadData, setFileUploadData] = useState([]);
  const [isValidMobile, setIsValidMobile] = useState(true);
  const [blockMemberList, setBlockMemberList] = useState([]);
  const [nblockMemberList, setnblockMemberList] = useState([]);
  const [uploadFileDetails, setUploadFileDetails] = useState("");
  const [uploadFileIsCSV, setUploadFileIsCSV] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [fileUploadFormData, setFileUploadFormData] = useState({
    m_name: "",
    m_mo_no: "",
    m_bussiness_name: "",
    m_business_category: "",
    m_city: "",
    m_block_reason: "",
    member_type: 1,
    created_by: loginUser?.u_id || 1
  });
  const [cityList, setCityList] = useState([]);
  const [filter, setFilter] = useState({
    // city_id:
    //   loginUser?.u_type == 1 ||
    //   (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
    //     ? loginUser?.city_id
    //     : 0,
    search: ""
  });
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [detailModal, setDetailModal] = useState(false);
  const toggleDetailModal = () => setDetailModal(!detailModal);

  const expo_columns = [
    { label: "No", key: "m_b_id" },
    { label: "Member Name", key: "m_name" },
    { label: "Member Mobile Number", key: "m_mo_no" },
    { label: "Member Business Name", key: "m_bussiness_name" },
    { label: "Member Business Category", key: "m_business_category" },
    { label: "City", key: "m_city" },
    { label: "Block Reason", key: "m_block_reason" },
    { label: "Added By", key: "created_by_name" }
  ];

  const columns = [
    {
      name: "No",
      selector: (row) => row?.m_b_id,
      wrap: true,
      sortable: true,
      width: "100px"
    },

    {
      name: "Member Name",
      wrap: true,
      selector: (row) => row?.m_name,
      sortable: true
    },
    {
      name: "Member Mobile Number",
      wrap: true,
      selector: (row) => row?.m_mo_no,
      sortable: true
    },
    {
      name: "Member Business Name",
      wrap: true,
      selector: (row) => row?.m_bussiness_name,
      sortable: true
    },
    {
      name: "Member Business Category",
      wrap: true,
      selector: (row) => row?.m_business_category,
      sortable: true
    },
    {
      name: "City",
      wrap: true,
      selector: (row) => row?.m_city || "-",
      sortable: true
    },
    {
      name: "Block Reason",
      wrap: true,
      selector: (row) => row?.m_block_reason || "-",
      sortable: true
    },
    {
      name: "Added By",
      wrap: true,
      selector: (row) => row?.created_by_name || "-",
      sortable: true
    },
    (loginUser?.u_type == 0 ||
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.management_p != 0)) && {
      name: "Action",
      sortable: true,
      width: "100px",
      wrap: true,
      selector: (row) => (
        <>
          <a
            onClick={() => {
              setDvisible({ mval: true, id: row?.m_b_id });
            }}
          >
            <Tooltip title="Delete Member">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </a>
        </>
      )
    }
  ].filter((f) => f != false);

  const checkMobileValid = (mobile) => {
    if (mobile != "") {
      const regex = /^(\+?91\s?)?(\d{10})$/;
      if (step == 1) {
        isValidMobile && setIsValidMobile(regex.test(mobile));
      } else {
        setIsValidMobile(regex.test(mobile));
      }
    } else {
      setIsValidMobile(true);
    }
  };
  const handleUploadedCSVFile = (e) => {
    setIsValidMobile(true);
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setUploadFileDetails(selectedFile.name);
      if (selectedFile.name.endsWith(".csv")) {
        setUploadFileIsCSV(true);
        const reader = new FileReader();

        reader.onload = (e) => {
          const csvData = e.target.result;
          parseCsvData(csvData);
        };

        reader.readAsText(selectedFile);
      } else {
        setIsValidMobile(false);
        setUploadFileIsCSV(false);
      }
    } else {
      setFileUploadData([]);
    }
  };
  const parseCsvData = (csvData) => {
    const customKeys = [
      "m_name",
      "m_mo_no",
      "m_bussiness_name",
      "m_business_category",
      "m_city",
      "m_block_reason"
    ];
    const lines = csvData.split("\n");
    const headers = lines[0].split(",");
    const parsedData = [];

    for (let i = 1; i < lines.length; i++) {
      const row = lines[i].split(",");
      if (row.length === customKeys.length) {
        const rowData = {};
        for (let j = 0; j < customKeys.length; j++) {
          if (customKeys[j] == "m_mo_no") {
            const regex = /^(\+?91\s?)?(\d{10})$/;
            checkMobileValid(row[j].trim());
            const value = row[j].trim();
            rowData[customKeys[j]] = value;
          } else {
            const value = row[j].trim();
            rowData[customKeys[j]] = value;
          }
        }

        parsedData.push({
          ...rowData,
          city_id: loginUser?.city_id || 0,
          created_by: loginUser?.u_id || 1
        });
      }
    }

    setFileUploadData(parsedData);
  };
  const handleFormSubmit = async () => {
    let payload = null;
    if (step == 0) {
      if (
        fileUploadFormData.m_name.trim().length != 0 &&
        fileUploadFormData.m_mo_no.trim().length != 0 &&
        fileUploadFormData.m_block_reason.trim().length != 0
      ) {
        const dnData = { ...fileUploadFormData, created_by: loginUser?.u_id || 1 };
        payload = { block_list: [dnData] };
      } else {
        let notify = notification({
          type: "error",
          message: "Please Enter Member Name, Contact Number & Block Reason"
        });
        notify();
      }
    } else if (step == 1) {
      const fnData = fileUploadData;
      payload = fnData.length > 0 ? { is_import: 1, block_list: fnData } : null;
    }

    if (payload) {
      setIsLoading(true);
      let res = await addBlockMemberApi(payload);
      setIsLoading(false);
      let notify = notification({
        type: res.status == 0 ? "error" : "success",
        message: res.message
      });
      notify();
      if (res.status == 1) {
        getBlockMember();
      }
      setIsValidMobile(true);
      toggleOpenUploadModal();
      setFileUploadData([]);
      setUploadFileDetails("");

      setFileUploadFormData({
        m_name: "",
        m_mo_no: "",
        m_bussiness_name: "",
        m_business_category: "",
        m_city: "",
        m_block_reason: ""
      });
    } else {
      let notify = notification({
        type: "error",
        message: "Please Check Your Form Data OR file before submitting Form"
      });
      notify();
    }
  };

  useEffect(async () => {
    await getBlockMember();
  }, []);

  const getBlockMember = async () => {
    setIsLoading(true);
    const result = await getBlockMemberCommonFunction(
      loginUser?.u_type === 0 ? 0 : loginUser?.u_id
    );
    setIsLoading(false);
    setBlockMemberList(result || []);
  };

  useEffect(async () => {
    await filterData();
  }, [filter, blockMemberList]);

  const filterData = async () => {
    let newData = [];
    newData =
      blockMemberList &&
      blockMemberList.filter((member) => {
        if (filter.search.trim().length != 0) {
          if (
            member.m_name.toLowerCase().includes(normalizeSearch(filter.search)) ||
            member.m_mo_no.toLowerCase().includes(normalizeSearch(filter.search)) ||
            member.m_bussiness_name.toLowerCase().includes(normalizeSearch(filter.search)) ||
            member.m_business_category.toLowerCase().includes(normalizeSearch(filter.search)) ||
            member.m_city.toLowerCase().includes(normalizeSearch(filter.search)) ||
            member.m_block_reason.toLowerCase().includes(normalizeSearch(filter.search)) ||
            member.created_by_name.toLowerCase().includes(normalizeSearch(filter.search))
          ) {
            return member;
          }
        } else {
          return member;
        }
      });
    setnblockMemberList(newData);
  };

  // useEffect(() => {
  //   getAllCityList();
  // }, []);
  // const getAllCityList = async () => {
  //   setCityList(await fetchallcitylist());
  // };

  const deleteMember = async (g_id) => {
    const resp = await deleteBlockMemberList({ m_b_id: g_id });
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      getBlockMember();
      setDvisible({ mval: false, id: 0 });
    }
  };

  const [detailsMemberBlockList, setDetailsMemberBlockList] = useState([]);

  const expo_detailMemberTableColumn = [
    { label: "Date", key: "n_m_date" },
    { label: "Invited By", key: "invite_by" },
    { label: "Member Mobile Number", key: "n_m_mo_no" },
    { label: "Member Name", key: "n_m_person_name" },
    { label: "Business Name", key: "n_m_business_name" },
    { label: "Business Category", key: "n_m_business_category" },
    { label: "Member Type", key: "member_in_chapter_type" },
    { label: "Invited At", key: "other_chapter_name" }
  ];
  const detailMemberTableColumn = [
    {
      name: "Date ",
      selector: (row) => row?.n_m_date,
      width: "170px"
    },

    {
      name: "Invited By",
      selector: (row) => row?.invite_by,
      sortable: true
    },
    {
      name: "Member Mobile Number",
      selector: (row) => row?.n_m_mo_no,
      sortable: true,
      width: "170px"
    },
    {
      name: "Member Name",
      selector: (row) => row?.n_m_person_name,
      sortable: true
    },
    {
      name: "Business Name",
      selector: (row) => row?.n_m_business_name,
      sortable: true
    },
    {
      name: "Business Category",
      selector: (row) => row?.n_m_business_category,
      sortable: true
    },
    {
      name: "Member Type",
      selector: (row) => row?.member_in_chapter_type,
      sortable: true
    },
    {
      name: "Invited At",
      selector: (row) => row?.other_chapter_name,
      sortable: true
    }
  ];

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deleteMember} />

      <Page title="Chapter's Member Block List | Local Vocal Business Group">
        <Container>
          {/* Upload CSV or Manually Add Modal */}
          <Modal
            open={openUploadModal}
            onClose={() => {
              setIsValidMobile(true);
              toggleOpenUploadModal();
              setFileUploadData([]);
              setUploadFileDetails("");
              setFileUploadFormData({
                m_name: "",
                m_mo_no: "",
                m_bussiness_name: "",
                m_business_category: "",
                m_city: "",
                m_block_reason: ""
              });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                {step == 0 ? "Add Member" : "Upload Member File"}
              </Typography>
              <Stack style={{ marginBottom: "15px" }}>
                {step == 1 ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} p={2}>
                      <label
                        className=""
                        htmlFor="CSVfile"
                        style={{
                          display: "flex",
                          margin: "auto",
                          marginTop: "25px",
                          justifyContent: "center",
                          width: "fit-content"
                        }}
                      >
                        <Label
                          variant="filled"
                          color="primary"
                          style={{
                            height: "40px",
                            width: "150px",
                            cursor: "pointer"
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center"
                            }}
                          >
                            Select File <FileUploadRounded />
                          </div>
                        </Label>
                        <input
                          id="CSVfile"
                          name="file"
                          type="file"
                          hidden
                          accept=".csv, text/csv"
                          className="form-control"
                          onChange={handleUploadedCSVFile}
                        />
                      </label>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={2} style={{ marginTop: "10px" }}>
                    <Grid item sm={6} xs={6}>
                      <Stack spacing={3}>
                        <TextField
                          required
                          label="Member Name"
                          name="m_name"
                          placeholder="Enter Member Name"
                          value={fileUploadFormData?.m_name}
                          autoComplete="off"
                          onChange={(e) => {
                            setFileUploadFormData({
                              ...fileUploadFormData,
                              m_name: e.target.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item sm={6} xs={6}>
                      <Stack spacing={3}>
                        <TextField
                          required
                          label="Member Contact Number"
                          name="m_mo_no"
                          autoComplete="off"
                          placeholder="Enter Contact Number"
                          value={fileUploadFormData?.m_mo_no}
                          onChange={(e) => {
                            checkMobileValid(e.target.value);
                            setFileUploadFormData({
                              ...fileUploadFormData,
                              m_mo_no: e.target.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item sm={6} xs={6}>
                      <Stack spacing={3}>
                        <TextField
                          label="Member Business Name"
                          name="m_bussiness_name"
                          autoComplete="off"
                          placeholder="Enter Member Business Name"
                          value={fileUploadFormData?.m_bussiness_name}
                          onChange={(e) => {
                            setFileUploadFormData({
                              ...fileUploadFormData,
                              m_bussiness_name: e.target.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item sm={6} xs={6}>
                      <Stack spacing={3}>
                        <TextField
                          label="Member Business Category"
                          name="m_business_category"
                          autoComplete="off"
                          placeholder="Enter Member Business Category"
                          value={fileUploadFormData?.m_business_category}
                          onChange={(e) => {
                            setFileUploadFormData({
                              ...fileUploadFormData,
                              m_business_category: e.target.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item sm={6} xs={6}>
                      <Stack spacing={3}>
                        <TextField
                          label="City"
                          name="m_city"
                          autoComplete="off"
                          placeholder="Enter City"
                          value={fileUploadFormData?.m_city}
                          onChange={(e) => {
                            setFileUploadFormData({
                              ...fileUploadFormData,
                              m_city: e.target.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item sm={6} xs={6}>
                      <Stack spacing={3}>
                        <TextField
                          required
                          label="Block Reason"
                          name="m_block_reason"
                          autoComplete="off"
                          placeholder="Enter Block Reason"
                          value={fileUploadFormData?.m_block_reason}
                          onChange={(e) => {
                            setFileUploadFormData({
                              ...fileUploadFormData,
                              m_block_reason: e.target.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                )}
                {uploadFileDetails != "" && (
                  <Label
                    variant={"ghost"}
                    color={"info"}
                    style={{
                      margin: "15px auto auto",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "fit-content",
                      paddingBottom: "5px",
                      paddingTop: "5px",
                      fontSize: "14px"
                    }}
                  >
                    Selected File : {uploadFileDetails}
                  </Label>
                )}
                {!isValidMobile && (
                  <Label
                    variant={"ghost"}
                    color={"error"}
                    style={{
                      margin: "15px auto auto",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "fit-content",
                      paddingBottom: "5px",
                      paddingTop: "5px",
                      fontSize: "14px"
                    }}
                  >
                    {!uploadFileIsCSV
                      ? "Upload File Must Be CSV"
                      : step == 1
                        ? "Please Check Mobile Number on Uploaded"
                        : "Please Enter Valid Mobile Number"}
                  </Label>
                )}
              </Stack>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsValidMobile(true);
                      toggleOpenUploadModal();
                      setFileUploadData([]);
                      setUploadFileDetails("");
                      setFileUploadFormData({
                        m_name: "",
                        m_mo_no: "",
                        m_bussiness_name: "",
                        m_business_category: "",
                        m_city: "",
                        m_block_reason: ""
                      });
                    }}
                    style={{ marginTop: "15px", marginRight: "15px" }}
                  >
                    Close
                  </Button>
                  <Button
                    // disabled={!isValidMobile}
                    variant="contained"
                    style={{ marginTop: "15px" }}
                    onClick={() => handleFormSubmit()}
                    disabled={isLoading || !isValidMobile}
                    startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                  >
                    Submit
                  </Button>
                </Grid>
              </Stack>
            </Box>
          </Modal>
          {/* Upload CSV or Manually Add Modal */}

          <Grid container>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  Member Blocked List
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => (setStep(0), setFileUploadData([]), toggleOpenUploadModal())}
                style={{
                  marginBottom: "15px",
                  float: "right"
                }}
                variant="contained"
              >
                Add Member
              </Button>
              <Button
                onClick={() => (setStep(1), setFileUploadData([]), toggleOpenUploadModal())}
                style={{
                  marginRight: "15px",
                  marginBottom: "15px",
                  float: "right"
                }}
                variant="contained"
              >
                Upload CSV
              </Button>
              <Button
                variant="outlined"
                style={{
                  marginRight: "15px",
                  marginBottom: "15px",
                  float: "right"
                }}
                onClick={() => {
                  saveAs(
                    `${Routes.API_HOSTNAME}member-block-list/memberblacklistimportsample.csv`,
                    `sample.csv`
                  );
                }}
              >
                Download Sample CSV
              </Button>
            </Grid>
          </Grid>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <Grid container spacing={2} style={{ marginBottom: "15px", marginTop: "0" }}>
              <Grid item xs={5}>
                <TextField
                  style={{ marginTop: "0px" }}
                  fullWidth
                  autoComplete="off"
                  type="text"
                  label="Search"
                  name="search_text"
                  size="small"
                  value={filter.search}
                  onChange={(e) => {
                    setFilter({ ...filter, search: e.target.value });
                  }}
                />
              </Grid>
              <Grid
                item
                xs={2}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "start"
                }}
              >
                <Button
                  onClick={() => {
                    setFilter({
                      city_id:
                        loginUser?.u_type == 1 ||
                        (loginUser?.u_type == 2 &&
                          loginUser?.p_user_id != 1 &&
                          loginUser?.management_p == 1)
                          ? loginUser?.city_id
                          : 0,
                      search: ""
                    });
                  }}
                  variant="outlined"
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
            <Button className="btn btn-export" style={{ padding: "0" }}>
              <CSVLink
                data={nblockMemberList}
                headers={expo_columns}
                filename={"Block Member Data.csv"}
                className="btn btn-primary test"
                target="_blank"
              >
                Export CSV
              </CSVLink>
            </Button>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={nblockMemberList}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>

        <Modal
          open={detailModal}
          onClose={() => toggleDetailModal()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={MemberModalStyle}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginBottom: "5px", textAlign: "center" }}
            >
              Member Invited List
            </Typography>
            <hr />
            <>
              <Button className="btn btn-export">
                <CSVLink
                  data={detailsMemberBlockList}
                  headers={expo_detailMemberTableColumn}
                  filename={`Detailed Member BlockList Report.csv`}
                  className="btn btn-primary test"
                  target="_blank"
                >
                  Export CSV
                </CSVLink>
              </Button>
              <DataTable
                filter
                fixedHeaderScrollHeight="450px"
                fixedHeader={true}
                pagination
                highlightOnHover
                columns={detailMemberTableColumn}
                data={detailsMemberBlockList}
              />
            </>
            <hr />
            <div
              style={{
                margin: "10px  auto 0",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleDetailModal()}
                style={{ marginTop: "0px", marginRight: "0px" }}
              >
                Close
              </Button>
            </div>
          </Box>
        </Modal>
      </Page>
    </>
  );
}
